import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { newsCommunicator } from '../../../communicators/newsCommunicator'

import NewsSection from '../NewsSection/NewsSection'

class FeaturedNewsSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            news: []
        }
    }

    componentDidMount() {
        this.loadNews()
    }

    async loadNews() {
        try {
            const { sectorId, categoryId, offset = 3 } = this.props

            const news = await newsCommunicator.fetchPage(3, null, {
                offset: offset,
                sector_id: sectorId,
                news_category_id: categoryId
            })
            this.setState({ news })
        } catch (error) {
            console.error(error)
        }
    }

    render() {
        const { news } = this.state

        return <NewsSection {...this.props} newsList={news} />
    }
}

FeaturedNewsSection.propTypes = {
    t: PropTypes.func,
    sectorId: PropTypes.number,
    categoryId: PropTypes.number
}

export { FeaturedNewsSection }
